// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/store.js";
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import { Message } from 'element-ui';
import VueI18n from 'vue-i18n'
import { Loading } from 'element-ui';
import './assets/css/global.css';
import {description} from './../package.json';

console.log("build :",description);
// Vue.use(ElementUI);
Vue.use(ElementUI, {
  VueI18n: (key, value) => i18n.t(key, value)
})
Vue.use(VueMoment, {
  moment,
});
//启动时的生产提示
Vue.config.productionTip = false;
// axios
import axios from "axios";
import Qs from "qs";
Vue.prototype.$chatApiURL = "https://chat.hk99555.com";

let lineURL = localStorage.getItem('lineUrl');
var instance;
// if (!lineURL) {
//   localStorage.setItem('lineUrl', window.__env.API_ROOT);
//   localStorage.setItem('lineUrlId', 1);
//   localStorage.setItem("lineUrlText", "线路一");
//   instance = axios.create({
//     baseURL: localStorage.getItem('lineUrl'), //process.env.API_ROOT
//     timeout: 10000,
//     withCredentials: true,
//     headers: {
//       'Content-Type': 'application/json; charset=utf-8'
//     }
//   });
//   Vue.prototype.$http = instance;

// } else {
  let initApp = function () {
  instance = axios.create({
    baseURL: localStorage.getItem('lineUrl'), //process.env.API_ROOT
    timeout: 10000,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  });
  Vue.prototype.$http = instance;
// }

// const instance = axios.create({
//   baseURL: process.env.API_ROOT, //process.env.API_ROOT
//   timeout: 10000,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json',
//     'Authorization': sessionStorage.getItem("token")
//   }
// });

instance.interceptors.request.use(
  (config) => {
    const useChatUrl = config.chatUrl;
    config.baseURL = useChatUrl ? localStorage.getItem('ownChatUrl') : localStorage.getItem('lineUrl');

    const isSimulateAccount = localStorage.getItem('isSimulation') === 'true';
    config.headers['Authorization'] = sessionStorage.getItem("token");
    config.headers['PartnerId'] = localStorage.getItem("partner_id") ? localStorage.getItem("partner_id") : '';
    config.headers['Clientip'] = localStorage.getItem("clientIp") ? localStorage.getItem("clientIp") : '';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    if (response.data.status == 401) {
      store.state.loginType = false;
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("simulateToken");
      sessionStorage.removeItem("loginType");
      sessionStorage.removeItem("couponCheck");
      router.push({
        path: "/login",
      });
      return Promise.reject(response);
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

Vue.prototype.$http = instance;



Vue.use(VueI18n)
Vue.prototype.$loadLangAsync = function (lang) {
  let loadingInstance = Loading.service({ fullscreen: true });
  return instance({
    url: "/app/i18n/list?lang="+lang,
    method: "post",
    data: {},
  }).then(function (res) {
    loadingInstance.close();
    if (res.data.status == 200) {
      let langList = res.data.data
      i18n.setLocaleMessage(lang, langList);
    }
    return true;
  }).catch(function (e) {
    loadingInstance.close();
    store.commit("setLang", 'zh');
    return false;
  });
}

Vue.prototype.$loadLangAsync('zh')

const i18n = new VueI18n({
  locale: 'zh',//'en', // 语言标识
  fallbackLocale: 'zh',
  messages: {
    'zh': require('./locale/zh'),
    // 'en': require('./locale/en'),
  }
}) 

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: h => h(App),//vue2.0的写法
  // components: { App }, vue1.0的写法
  template: "<App/>"
});

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});
  }
let Line_1 = window.__env.Line_1;
let Line_2 = window.__env.Line_2;
 
Vue.prototype.$URLs = [{ "id": 1, "name": "线路一", "url": window.__env.API_ROOT  }, { "id": 2, "name": "线路二", "url": Line_1}, { "id": 3, "name": "线路三", "url": Line_2}];
Vue.prototype.$endURLs = [{ "id": 1, "name": "线路一", "url": window.__env.API_ROOT +"app/Home/configs" }, { "id": 2, "name": "线路二", "url": Line_1 +"app/Home/configs"}, { "id": 3, "name": "线路三", "url": Line_2 +"app/Home/configs"}];

let lines= Vue.prototype.$URLs;
let endUrls= Vue.prototype.$endURLs;
let workingLines = [];

let checkLine = function (url) {

  return new Promise((resolve, reject) => {
    if(url === null || url === undefined){reject();return;};
    fetch(url,{method: 'POST'}, { mode: 'no-cors' })
      .then(response => {
        resolve();
      })
      .catch(error => {
        reject();
      });
  });
}

let sortedLine = function () {
  lineSelectPromise.then(res => {
    sessionStorage.setItem("lineUrlChange", 0);
    console.log(workingLines);

    workingLines.sort((a, b) => (a.time > b.time) ? 1 : -1)
    let lineURL = workingLines.length > 0 ? workingLines[0].url : window.__env.API_ROOT;
    let lineURLText = workingLines.length > 0 ? workingLines[0].name : lines[0].name;
    let lineUrlId = workingLines.length > 0 ? workingLines[0].id : lines[0].id;

    if (lineURL) {
      localStorage.setItem('lineUrl', lineURL);
      sessionStorage.setItem('lineUrl',lineURL);
      localStorage.setItem('lineUrlText', lineURLText);
      sessionStorage.setItem('lineUrlText',lineURLText);
      localStorage.setItem('lineUrlId', lineUrlId);
      sessionStorage.setItem('lineUrlId',lineUrlId);
    } else {
      localStorage.setItem('lineUrl',window.__env.API_ROOT);
      sessionStorage.setItem('lineUrl',window.__env.API_ROOT);
      localStorage.setItem('lineUrlText', lines[0].name);
      sessionStorage.setItem('lineUrlText',lines[0].name);
      localStorage.setItem('lineUrlId', lines[0].id);
      sessionStorage.setItem('lineUrlId',lines[0].id);
    }
    initApp();
  })
}

let lineSelectPromise = new Promise((resolve, reject) => {
  endUrls.forEach((value, index, array) => {
    let startTime = new Date().getTime();
    fetch(value.url, {method: 'POST'}, { mode: 'no-cors' })
      .then(response => {
        let endTime = new Date().getTime();
        let elapsedTime = endTime - startTime;
        let item = {};
        item.time = elapsedTime;
        item.url = lines[index].url;
        item.name=value.name;
        item.id=value.id;

        workingLines.push(item);
        if (index === array.length - 1 || workingLines.length > 1) resolve();

      })
      .catch(error => {
        console.error("Fetch error2:", error);

        if (index === array.length - 1) resolve();
      });
  })
})

//continue with current api line if it's working
let storedLine = sessionStorage.lineUrl;
let storedLineUrl = sessionStorage.lineUrl+"app/Home/configs";
let lineUrlChange = sessionStorage.lineUrlChange;

if(lineUrlChange == 1){
  checkLine(storedLineUrl).then(() => {
    sessionStorage.setItem("lineUrlChange", 0);
    initApp();
  }).catch(() => {
    sortedLine()
  })
}else{
  sortedLine()
}
  




// WEBPACK FOOTER //
// ./src/main.js